export function calculateBondUnderlyingAsset(initialStrikeDirty: number, legalDenomination: number, assetDenomination: number): number | null {
  if (initialStrikeDirty <= 0 || assetDenomination <= 0) {
    return null;
  }
  return Math.floor((legalDenomination / assetDenomination) * (1 / initialStrikeDirty ));
}
